import { render, staticRenderFns } from "./ProctorGenerate.vue?vue&type=template&id=250b6e1c&scoped=true"
import script from "./ProctorGenerate.vue?vue&type=script&lang=js"
export * from "./ProctorGenerate.vue?vue&type=script&lang=js"
import style0 from "./ProctorGenerate.vue?vue&type=style&index=0&id=250b6e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250b6e1c",
  null
  
)

export default component.exports